const transformed = (input) => {
  return {
    ...input,
    link: {
      label: input.linkLabel || input.label,
      url: input.linkUrl || input.url
    }
  };
};

export default transformed;
